import { render, staticRenderFns } from "./viewLGFED.vue?vue&type=template&id=fc749548&scoped=true"
import script from "./viewLGFED.vue?vue&type=script&lang=js"
export * from "./viewLGFED.vue?vue&type=script&lang=js"
import style0 from "./viewLGFED.vue?vue&type=style&index=0&id=fc749548&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc749548",
  null
  
)

export default component.exports